var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frame"},[_c('Top'),_c('fix-box'),_c('router-view',{key:_vm.$route.params.parentCode}),_c('Foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }